import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import mapboxgl from 'mapbox-gl';
import MapboxDraw from '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw';

//import Toggle from 'material-ui/Toggle';

import 'mapbox-gl/dist/mapbox-gl.css'

mapboxgl.accessToken = 'pk.eyJ1IjoibmlzYWxwIiwiYSI6ImNqN2gyM2FobzFldWgycW80c2xjcGxmOWQifQ.jxSesKUpy14T6X_-0cqHFw';

export default class Mapbox extends Component {
    constructor(props){
        super(props);
        this.map = null;
        this.draw = null;
        this.state = {
            satelite: false,
            polygonGeoJSONData: [],
            pointsGeoJSONData: [],
        }
    }

    drawMarkers(newMarkers) {
        let newMarkerFeatures = [];

        for (let cur of newMarkers) {
            let curFeature = {
                type: "Feature",
                geometry: cur.geo,
                properties: {
                    htmlContent: cur.htmlContent,
                    fillColor: cur.color || '#FF586D',
                }
            }
            newMarkerFeatures.push(curFeature);
        }

        const markerSource = this.map.getSource('markers');

        if (!_.isUndefined(markerSource)) {
            markerSource.setData({
                type: 'FeatureCollection',
                features: newMarkerFeatures,
            });
        }
    }

    drawPolygons(polygons) {
        let newPolygonFeatures = [];
    
        // DRAW FENCES RETRIEVED FROM THE SERVER
        for (let cur of polygons) {
            let curPolygon = {
                type: "Feature",
                geometry: cur.geo,
                properties: {
                    htmlContent: cur.htmlContent,
                    fillColor: cur.color,
                    outlineColor: '#fff',
                }
            }
            newPolygonFeatures.push(curPolygon);
        }
        const polygonSource = this.map.getSource('polygons');

        if (!_.isUndefined(polygonSource)) {
            polygonSource.setData({
                type: "FeatureCollection",
                features: newPolygonFeatures,
            });
        }
    }

    setMapStyles(){
        const self = this;

        self.map.addLayer({ 
            'type': 'raster', 
            'id': 'satellite-map', 
            'source': 'mapbox-satellite',
            'layout': {
                'visibility': 'none',
            },
        });

        self.map.addLayer({
            'id': 'polygons',
            'type': 'fill',
            'source': 'polygons',
            'paint': {
                'fill-color': ['get', 'fillColor'],
                'fill-outline-color': ['get', 'outlineColor'],
                'fill-opacity': 0.5,
            },
        });

        self.map.addLayer({
            'id': 'markers',
            'type': 'circle',
            'source': 'markers',
            'paint': {
                'circle-color': ['get', 'fillColor'],
                'circle-stroke-width': 1,
                'circle-stroke-color': '#fff',
                'circle-radius': [
                    'step',
                    ['get', 'point_count'],
                    20,
                    200,
                    30,
                    1500,
                    40
                ]
            },
        });

        self.map.on('click', 'markers', function (e) {
            new mapboxgl.Popup()
                .setLngLat(e.features[0].geometry.coordinates)
                .setHTML(e.features[0].properties.htmlContent)
                .addTo(self.map);
        });

        /*
    
        // Change the cursor to a pointer when the mouse is over the places layer.
        self.map.on('mouseenter', 'pointFences', function () {
            self.map.getCanvas().style.cursor = 'pointer';
        });
    
        // Change it back to a pointer when it leaves.
        self.map.on('mouseleave', 'pointFences', function () {
            self.map.getCanvas().style.cursor = '';
        });
        */

        // Polygon Pop ups
        self.map.on('click', 'polygons', function (e) {
            new mapboxgl.Popup()
                .setLngLat(e.lngLat)
                .setHTML(e.features[0].properties.title)
                .addTo(self.map);
        });
    
        // Change the cursor to a pointer when the mouse is over the places layer.
        self.map.on('mouseenter', 'polygons', function () {
            self.map.getCanvas().style.cursor = 'pointer';
        });
    
        // Change it back to a pointer when it leaves.
        self.map.on('mouseleave', 'polygons', function () {
            self.map.getCanvas().style.cursor = '';
        });
    }

    componentDidMount(){
        this.map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mapbox/streets-v9',
        });

        const self = this;

        self.map.addControl(new mapboxgl.NavigationControl());

        self.map.on('load', ()=> {
            self.map.addControl(new mapboxgl.GeolocateControl({
                positionOptions: {
                    enableHighAccuracy: true
                },
                trackUserLocation: true
            }));

            const geoJSONStructure = {
                "type": "FeatureCollection",
                "features": []
            };

            self.map.addSource('polygons', { type: 'geojson', data: geoJSONStructure });
            self.map.addSource('markers', { type: 'geojson', data: geoJSONStructure });
            self.map.addSource("mapbox-satellite", { "type": "raster", "url": "mapbox://mapbox.satellite", "tileSize": 256 }); 
            
            self.setMapStyles();
        });

        self.map.on('zoom', (e) => {
            if (_.isFunction(self.props.centerChanged)) self.props.centerChanged();
            if (_.isFunction(self.props.setMapBounds)) self.props.setMapBounds(null);

            const bounds = self.map.getBounds();
            const boundsFormatted = {
                topLeft: [bounds.getWest(), bounds.getNorth()],
                bottomRight: [bounds.getEast(), bounds.getSouth()],
            };

            if (_.isFunction(self.props.viewpointChanged)) {
                self.props.viewpointChanged(
                    boundsFormatted.topLeft,
                    boundsFormatted.bottomRight,
                );
            }
        });
        
        self.map.on('dragend', (e) => {
            const bounds = self.map.getBounds();
            const boundsFormatted = {
                topLeft: [bounds.getWest(), bounds.getNorth()],
                bottomRight: [bounds.getEast(), bounds.getSouth()],
            };

            if (_.isFunction(self.props.viewpointChanged)) {
                self.props.viewpointChanged(
                    boundsFormatted.topLeft,
                    boundsFormatted.bottomRight,
                );
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        let nextPolygonsSorted = [];
        let nextMarkersSorted = [];

        if (!_.isUndefined(nextProps.markers)) {
            nextMarkersSorted = nextProps.markers;
        }

        if (!_.isUndefined(nextProps.polygons)) {
            nextPolygonsSorted = nextProps.polygons;
        }

        this.drawPolygons(nextPolygonsSorted);
        this.drawMarkers(nextMarkersSorted);

        // Map position management
        if (!_.isNull(nextProps.mapCenter)) {
            this.map.setZoom(18);
            this.map.setCenter([
                nextProps.mapCenter.lng,
                nextProps.mapCenter.lat,
            ]);
        }

        if (!_.isUndefined(nextProps.mapBounds) 
            && !_.isNull(nextProps.mapBounds) 
            && !_.isUndefined(nextProps.mapBounds.southwest) && !_.isUndefined(nextProps.mapBounds.northeast)) {
            this.map.fitBounds([
                [
                    nextProps.mapBounds.southwest.lng,
                    nextProps.mapBounds.southwest.lat,
                ],
                [
                    nextProps.mapBounds.northeast.lng,
                    nextProps.mapBounds.northeast.lat,
                ],
            ])
        }
    }

    // UI Event listeners
    handleUpdateInput(e, value){
        if (_.isFunction(this.props.updateSearchTerm)) {
            this.props.updateSearchTerm(value);
        }
    }
    setMapBounds(data){
        if (_.isFunction(this.props.setMapBounds)){
            this.props.setMapBounds(data);
        }
    }
    toggleMapType(event, value){
        const self = this;

        if (value) {
            if (!_.isUndefined(self.map.getLayer('satellite-map'))) {
                self.map.setLayoutProperty('satellite-map', 'visibility', 'visible');
            }
        } else {
            if (!_.isUndefined(self.map.getLayer('satellite-map'))) {
                self.map.setLayoutProperty('satellite-map', 'visibility', 'none');
            }
        }
    }

  render() {
      return (
          <div style={{width:"100%", height:"100%", position: 'relative'}}>
            <div className="map-type-switch">
                {/*
                <Toggle
                    defaultToggled={false}
                    label=""
                    labelPosition="left"
                    onToggle={this.toggleMapType.bind(this)}
                />
                */}
            </div>
            <div id="map" style={{width:"100%", height:"100%"}}>    
            </div>
          </div>
      );
    }
}

//React.PropTypes.func,

Mapbox.propTypes = {
    drawMode: PropTypes.bool,
    markers: PropTypes.array,

    viewpointChanged: PropTypes.func,
    centerChanged: PropTypes.func,
}
Mapbox.defaultProps = {
    drawMode: true,
    markers: [],
}


// WEBPACK FOOTER //
// ./src/shared/components/Mapbox.js